import React from 'react';
import moment from 'moment';
import LineChart from '../../../../shared/line-chart';
import WhiteContainer from '../../../../shared/white-container';


interface ILineChartDetails {
    data?: any;
}

const LineChartDetails = ({
    data
}: ILineChartDetails) => {


    const formatDate = (dateStr: string): string => {
        const date = moment(dateStr, ["YYYY-MM", "YYYY-MM-DD"], true);

        if (!date.isValid()) return "Invalid date";

        return dateStr.length === 7 ? date.format("MMM") : date.format("DD MMM");
    };

    return (
        <WhiteContainer type='rounded'>
            <div>
                <div className='flex flex-row justify-start items-center relative'>
                    <p className='font-bold mb-4'>Session End States</p>
                </div>
                <div>
                    <LineChart
                        xAxisData={data && data?.length > 0 ? data?.map((item: any) => formatDate(item?.date)) : []}
                        // chartData={data && data?.length > 0 ? data?.map((item: any) => item?.data) : [1, 3]}
                        completedData={data && data?.length > 0 ? data?.map((item: any) => item?.completed) : []}
                        progressData={data && data?.length > 0 ? data?.map((item: any) => item?.inProgress) : []}
                        failedData={data && data?.length > 0 ? data?.map((item: any) => item?.failed) : []}
                        manualData={data && data?.length > 0 ? data?.map((item: any) => item?.manualReview) : []}
                    />
                </div>
            </div>
        </WhiteContainer>
    )
}

export default LineChartDetails;